const LOAD_DEVICE_RESOURCES = "device-resources::load";
const LOAD_DEVICE_RESOURCES_SUCCESS = "device-resources::load::success";
const UNLOAD_DEVICE_RESOURCES = "device-resources::unload";

const unloadDeviceResourcesAction = {
  type: UNLOAD_DEVICE_RESOURCES,
};

export {
  LOAD_DEVICE_RESOURCES,
  LOAD_DEVICE_RESOURCES_SUCCESS,
  UNLOAD_DEVICE_RESOURCES,
  unloadDeviceResourcesAction,
};
